(function () {
  function initTabs(section) {
    var tabs = section.querySelectorAll('.basiq-featured__tab');
    var panels = section.querySelectorAll('.basiq-featured__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var targetId = tab.dataset.tabTarget;

        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });

        tab.classList.add('is-active');
        var targetPanel = section.querySelector('[data-tab-panel="' + targetId + '"]');
        if (targetPanel) targetPanel.classList.add('is-active');
      });
    });
  }

  function initDragScroll(track) {
    var isDown = false;
    var startX;
    var scrollLeft;

    track.addEventListener('mousedown', function (e) {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });

    ['mouseleave', 'mouseup'].forEach(function (evt) {
      track.addEventListener(evt, function () {
        isDown = false;
        track.classList.remove('is-dragging');
      });
    });

    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.2;
      track.scrollLeft = scrollLeft - walk;
    });
  }

  function initAll() {
    document.querySelectorAll('.basiq-featured').forEach(function (section) {
      if (section.dataset.featuredInit === 'true') return;
      section.dataset.featuredInit = 'true';

      initTabs(section);
      section.querySelectorAll('.basiq-featured__track').forEach(initDragScroll);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();